export enum GridMode {
    Grid = 1,
    List = 2,
    Card = 3
}